module.exports = __webpack_public_path__ + "img/cv-logo.b608f82d.png";